import React from "react";
import EntityEmptyPage from "components/Records/NewRecordPages/EntityEmptyPage";
import AddAddressesPopup from "./AddAddressesPopup";

interface AddressesEmptyPageProps {
  onAddressesCreated?: (newAddresses: any) => void;
}

export default function AddressesEmptyPage({ onAddressesCreated }: AddressesEmptyPageProps) {
  return (
    <EntityEmptyPage
      title="Addresses"
      colorKey="community"
      AddPopupComponent={AddAddressesPopup}
      onEntityCreated={onAddressesCreated}
      items={[
        {
          id: "select",
          type: "text",
          text: "Select an Address",
          direction: "left",
        },
        {
          id: "create",
          type: "button",
          label: "Create New Address",
          openPopup: true,
        },
      ]}
    />
  );
}
